import React from 'react';
import { withRouter } from 'react-router';
import Modal from "react-bootstrap/Modal";
import * as actions from '../../../store/actions';
import { connect } from 'react-redux';

const GuideModal = (props) => {
	let isShow = '';
	if(props.modelGuideOpen === true){
		isShow = 'show';
	}
	return(				
        <Modal size="md" show={props.modelGuideOpen}>
			<Modal.Header>
                <ul className="nav nav-tabs nav-line nav-color-secondary no-bd" role="tablist">
			   		<li className="nav-item">
			   			<a data-toggle="tab" role="tab" aria-selected="true" className="nav-link show cursor_pointer active"> Guided View </a>
			   		</li>			   		
			   	</ul>
            </Modal.Header>
            <Modal.Body>
            	<p> This will take you step by step and help you to understand the below Configurations. </p>
            	<div className="card-body border">
   					<ul className="nav nav-pills nav-secondary" id="pills-tab" role="tablist">
   						<li className="nav-item submenu">
   							<a className="nav-link active show" id="pills-home-tab" data-toggle="pill" href="#hintSheet" role="tab" aria-controls="pills-home" aria-selected="true">Sheet</a>
   						</li>
   						<li className="nav-item submenu">
   							<a className="nav-link" id="pills-profile-tab" data-toggle="pill" href="#hintCalculation" role="tab" aria-controls="pills-profile" aria-selected="false">Calculation</a>
   						</li>
   						<li className="nav-item submenu">
   							<a className="nav-link" id="pills-contact-tab" data-toggle="pill" href="#hintAssignment" role="tab" aria-controls="pills-contact" aria-selected="false">Assignment</a>
   						</li>
   					</ul>
   					<div className="tab-content mt-2 mb-3" id="pills-tabContent">
   						<div className="tab-pane fade active show" id="hintSheet" role="tabpanel" aria-labelledby="pills-home-tab">
   							<p> We can use the Inputs from the Sheet in the form of Filter which is selected in Choose Rates Sheet Pick-List </p> 
   						</div>
   						<div className="tab-pane fade" id="hintCalculation" role="tabpanel" aria-labelledby="pills-profile-tab">
   							<p> We can build an Expression / Business Logic using the Input Fields, Expressions and Assign the result of Output Fields under Output Mapping Section.
   							</p>
   						</div>
   						<div className="tab-pane fade" id="hintAssignment" role="tabpanel" aria-labelledby="pills-contact-tab">
   							<p> We can build an Expression / Business Logic using the Input Fields, Expressions and Assign the result of Output Fields under Output Mapping Section.
   							</p>
   						</div>
   					</div>
   				</div>
            </Modal.Body>
            <Modal.Footer>
               <div className="ml-md-auto py-2 py-md-0">
                    {/*<a onClick={props.toogleGuideHandler} className="btn btn-border border-default mr-2" data-dismiss="modal"> Cancel </a> */}
                    <a onClick={props.toogleGuideHandler } className="btn primary_bg" data-dismiss="modal"> Got it, Continue </a> 
                    {props.ratesListCount > 1? <a onClick={props.guideDontShowHandler } className="btn primary_bg ml-2" data-dismiss="modal"> Thanks, Don't show again </a> :null}
                </div>
            </Modal.Footer>	
        </Modal>			
	)
}

const mapDispatchToProps = dispatch => {
    return {
      Loader : () => dispatch(actions.loader()),
      succMessage : (msg) => dispatch(actions.succMessage(msg)),
      failMessage : (msg) => dispatch(actions.failMessage(msg))      
    };
}
export default
	connect(
	  null, 
	  mapDispatchToProps
	)(withRouter(GuideModal));